import Body from "../../../../../../material/skeleton/Body";
import Footer from "../../../../../../material/skeleton/Footer";
import Box from "@mui/material/Box";
import NotifyClientPrice from "./NotifyClientPrice";
import ClientInvoiceDetails from "../common/ClientInvoiceDetails";
import NotifyElectronicSignature from "./NotifyElectronicSignature";
import {Button, CircularProgress, Slide} from "@mui/material";
import {Error} from "@mui/icons-material";
import {useEffect, useState} from "react";
import Modal from "../../../../../../material/modal/Modal";
import ModalConfig from "../../../../../../material/modal/ModalConfig";
import ElectronicSignatureTutorial from "../common/electronic-signature/ElectronicSignatureTutorial";
import SkipSignature from "./SkipSignature";
import Typography from "@mui/material/Typography";
import parameter from "../../../../../../enum/parameter";

export default function ({qualityInspectionId, clientId, interventionId, orderId}) {
    const [openHelp, setOpenHelp] = useState(false);
    const [skipSignature, setSkipSignature] = useState(false);
    const [open, setOpen] = useState(false);

    useEffect(() => {
        setTimeout(() => {
            setOpen(true);
        }, 4000);
    }, []);

    const toggleOpenHelp = o => () => setOpenHelp(o);
    const toggleSkipSignature = o => () => {
        setSkipSignature(o);

        if (o) toggleOpenHelp(false)();
    }

    return (
        <>
            <Body sx={{pb: 8}}>
                <Box mt={2}>
                    <NotifyClientPrice interventionId={interventionId}/>
                </Box>
                <Box mt={2} px={1}>
                    <ClientInvoiceDetails interventionId={interventionId}/>
                </Box>
                {
                    !skipSignature
                        ? (
                            <Slide in={open} direction={"up"}>
                                <div>
                                    <Box mt={2}>
                                        <NotifyElectronicSignature/>
                                    </Box>
                                    <Box mt={5} px={2} display="flex" justifyContent="center">
                                        <Button
                                            startIcon={<Error/>}
                                            variant={"contained"}
                                            color={"error"}
                                            fullWidth
                                            onClick={toggleOpenHelp(true)}
                                            data-test="open-signature-tutorial"
                                        >
                                            Le sociétaire rencontre un problème
                                        </Button>
                                    </Box>
                                </div>
                            </Slide>
                        )
                        : (
                            <Box mt={5} px={2}>
                                <SkipSignature interventionId={interventionId} qualityInspectionId={qualityInspectionId}/>
                            </Box>
                        )
                }


                {
                    openHelp
                        ? (
                            <Modal
                                modalConfig={
                                    new ModalConfig()
                                        .setWidth("100%")
                                        .setHeight("100%")
                                        .setOnClose(toggleOpenHelp(false))
                                        .setComponent(<ElectronicSignatureTutorial onSkip={toggleSkipSignature(true)}/>)
                                }
                            />
                        )
                        : null
                }
            </Body>
            <Footer>
                <Button
                    sx={{height: parameter.FOOTER_HEIGHT, borderRadius: 0}}
                    variant="contained"
                    fullWidth
                    size={"large"}
                    disabled={true}
                >
                    <CircularProgress size={20} color={"inherit"}/>
                    <Typography display="inline">
                        &nbsp;Attente de {skipSignature ? "la photo du devis" : "signature"}
                    </Typography>
                </Button>
            </Footer>
        </>
    )
}